export class ContentnonJVFlying {
  overlayImage: string;
  name: string;
  description: string;
  descriptionOther: string;
  flightOnlyButtonLabel: string;
  externalLinkButtonLabel: string;
  travelplusDomain: string;
  disclaimer: string;

  constructor(contentjson?: any) {
    if (contentjson) {
      if (contentjson['overlayImage']) {
        this.overlayImage = contentjson['overlayImage'];
      }
      if (contentjson['name']) {
        this.name = contentjson['name'];
      }
      if (contentjson['description']) {
        this.description = contentjson['description'];
      }
      if (contentjson['descriptionOther']) {
        this.descriptionOther = contentjson['descriptionOther'];
      }
      if (contentjson['flightOnlyButtonLabel']) {
        this.flightOnlyButtonLabel = contentjson['flightOnlyButtonLabel'];
      }
      if (contentjson['externalLinkButtonLabel']) {
        this.externalLinkButtonLabel = contentjson['externalLinkButtonLabel'];
      }
      if (contentjson['travelplusDomain']) {
        this.travelplusDomain = contentjson['travelplusDomain'];
      }
      if (contentjson['disclaimer']) {
        this.disclaimer = contentjson['disclaimer'];
      }
    }
  }
}
